import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  container: {
    backgroundColor: '#edf7f4',
    height: 16,
    width: '100%',
    position: 'relative',
    borderRadius: 2,
    overflow: 'hidden',
  },
  innerBar: {
    backgroundColor: '#4eab96',
    height: 16,
  },
}

const HorizontalBar = ({
  classes,
  percentFilled,
  children,
  className,
  innerClassName,
}) => (
  <div className={classNames(classes.container, className)}>
    <div
      className={classNames(classes.innerBar, innerClassName)}
      style={{
        width: percentFilled + '%',
      }}
    />
    {children}
  </div>
)

export default injectStyles(styles)(HorizontalBar)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartRaw/HorizontalBar.js